import HeroCard from "../components/home/HeroCard";
import { notification } from "antd";
import QuickLinksCard from "../components/home/QuickLinksCard";
import SessionHistoryTable from "../components/home/SessionHistoryTable";
import { useAuth } from "../context/AuthContext";
import { Card, Tabs } from "antd";

const Home = () => {
  const { currentUser, loading } = useAuth(); 
  const [api, contextHolder] = notification.useNotification();

  const errorNotification = (message, description) => {
    api.error({
      message,
      description,
      placement: "bottomRight",
      duration: 5,
      showProgress: true,
    });
  };

  return (
    <div className="h-full box-border px-12 py-6">
      {contextHolder}
      <HeroCard />
      <div className="flex flex-row gap-4 mt-8">
        <Card className="w-3/4">
          <Tabs defaultActiveKey="individual">
            <Tabs.TabPane tab="Individual Sessions" key="individual">
              <SessionHistoryTable userId={currentUser.id} type="individual" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Cohort Sessions" key="cohort">
              <SessionHistoryTable userId={currentUser.id} type="cohort" />
            </Tabs.TabPane>
          </Tabs>
        </Card>
        <QuickLinksCard />
      </div>
    </div>
  );
};

export default Home;
